const LIVE_ID_KEY = 'stream-activity-live-id';
const LIVE_TOKEN_KEY = 'stream-activity-live-token';

function generateId(): string {
  return crypto.randomUUID();
}

export interface LiveCredentials {
  liveId: string;
  liveToken: string;
}

export function getLiveCredentials(): LiveCredentials {
  let liveId = '';
  let liveToken = '';
  try {
    liveId = localStorage.getItem(LIVE_ID_KEY) || '';
    liveToken = localStorage.getItem(LIVE_TOKEN_KEY) || '';
  } catch {}
  if (!liveId || !liveToken) {
    liveId = generateId();
    liveToken = generateId();
    try {
      localStorage.setItem(LIVE_ID_KEY, liveId);
      localStorage.setItem(LIVE_TOKEN_KEY, liveToken);
    } catch {}
  }
  return { liveId, liveToken };
}
